import styled from "styled-components";
import { createMuiTheme } from "@material-ui/core";

export const Container = styled.div`
  margin-top: 40px;
  padding: 30px;
`;

export const toraTheme = createMuiTheme({
  palette: {
    primary: {
      main: "#1e824c"
    }
  }
});
